import { HttpHeaders, HttpParams } from '@angular/common/http';

export class PershingHttpUtil {
    static interceptors: { [option: string]: string } = {
        'jwt': 'DISABLE-JWT',
        'esf': 'DISABLE-ESF'
    };

    /**
     * This method returns an options object with the headers property.
     * It takes in an array of strings that indicate which interceptors
     * are to be be disabled. It adds those disable headers to the request,
     * and the interceptors read these disable headers. An optional headers
     * argument can be passed to include any additional headers
     *
     * @param args
     * @param headers
     */
    static disableInterceptors(args: string[], headers?: any): any {
        let disableHeaders = {};
        args.forEach(options => {
            let disableHeader = this.interceptors[options];
            if (disableHeader) { disableHeaders[disableHeader] = ''; }
        });
        return {
            headers: new HttpHeaders({
                ...headers,
                ...disableHeaders
            })
        };
    }

    static secureUrl(headers?: any): HttpHeaders {
        return new HttpHeaders({
            ...headers,
            ... { 'secure-url': '' }
        });
    }

    static resolveResourcePath(name: string, path: string, appSettings: any): string {
        let resourcePath = path;
        if (appSettings && appSettings.cdnAttributes) {
            let cdnAttributes = appSettings.cdnAttributes;
            if (cdnAttributes.cdnPath && path.includes('node_modules')) {
                resourcePath = cdnAttributes.cdnPath + path.replace('node_modules', '');
                if (cdnAttributes.artifacts && cdnAttributes.artifacts[name]) {
                    let cdnPathSeperator = cdnAttributes.cdnSeparator ? cdnAttributes.cdnSeparator : '/';
                    resourcePath = resourcePath.replace(name, name + cdnPathSeperator + cdnAttributes.artifacts[name]);
                }
            }
        }
        return resourcePath;
    }

    // this function will check whether the URL requested is permisible to set the JWT token header by computig with AppSettings data
    static isAuthRequired(url: string, appSettings: any): boolean {
        let authRequired: boolean = false;
        let authRequiredDomains: Array<string> = new Array<string>();
        if (appSettings) {
            if (appSettings.domainUrl) {
                authRequiredDomains.push(appSettings.domainUrl);
            }
            if (appSettings.additionalAuthHeaderDomains && appSettings.additionalAuthHeaderDomains.length > 0) {
                authRequiredDomains = authRequiredDomains.concat(appSettings.additionalAuthHeaderDomains);
            }
        }

        for (let index = 0; index < authRequiredDomains.length; index++) {
            let domain: string = authRequiredDomains[index];
            if (url.indexOf(domain) > -1) {
                authRequired = true;
                break;
            }

        }
        return authRequired;
    }

    private static isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }

    static mergeDeep(source, target) {
        let output = Object.assign({}, source);
        if (this.isObject(source) && this.isObject(target)) {
            Object.keys(target).forEach(key => {
                if (this.isObject(target[key])) {
                    if (!(key in source)) {
                        Object.assign(output, { [key]: target[key] });
                    } else {
                        output[key] = this.mergeDeep(source[key], target[key]);
                    }
                } else {
                    Object.assign(output, { [key]: target[key] });
                }
            });
        }
        return output;
    }

    /** This method convert the  querystring to object(JSON)
     * @queryString
     *  sample querystring 'page=balances&domaintype=account&account=511000000'
     */
    static getJsonObjectFromQueryString(queryString: any): any {
        if (queryString && queryString.length > 0) {
            let httpParams = undefined;
            httpParams = new HttpParams({ fromString: queryString });
            const paramsObject = httpParams.keys().reduce((param, key) => {
                param[key] = httpParams.get(key);
                return param;
            }, {});
            return paramsObject;
        } else {
            return {};
        }
    }

    /** This method convert jsonobject to querystring
     * accepts only key value pair
     * @param jsonObject
     * sample jsonObject '{page: 'balance' , domaintype: 'account', account: '511000000'}'
     */
    static getQueryStringFromJsonObject(jsonObject: any): any {
        if (jsonObject && jsonObject instanceof Object) {
            Object.keys(jsonObject).forEach(key => jsonObject[key] == null && delete jsonObject[key]);
            let queryString = Object.keys(jsonObject).map((key) => {
                return `${encodeURIComponent(key)}=${encodeURIComponent(jsonObject[key])}`;
            }).join('&');
            return queryString;
        } else {
            // If not Object return input as is
            return jsonObject;
        }
    }
}
